import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'components/atoms'
import * as S from './styled'
import { theme } from 'utils/theme'

const InputText = ({
  onChange,
  value,
  width,
  height,
  placeholder,
  icon,
  iconWidth,
  iconHeight,
  iconColor,
  className,
  onFocus,
}) => {
  return (
    <S.InputContainer width={width} height={height} className={className}>
      <S.FormGroup>
        <input className='form-control' value={value} onChange={onChange} placeholder={placeholder} onFocus={onFocus} />
        {icon && <Icon Source={icon} width={iconWidth} height={iconHeight} color={iconColor} />}
      </S.FormGroup>
    </S.InputContainer>
  )
}

InputText.defaultProps = {
  value: '',
  width: '',
  height: '',
  placeholder: '',
  icon: null,
  iconWidth: '18px',
  iconHeight: '14px',
  iconColor: theme.colors.white,
  className: '',
  onFocus: () => {},
}

InputText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  onFocus: PropTypes.func,
}

export default InputText
